require ['jquery', 'custom/controller', 'custom/media-query', 'lib/inview', 'custom/forms', 'bootstrap/util', 'bootstrap/modal', 'lib/kryptonite', 'lib/cookie'], ($, controller, mq, forms) ->
  $ ->
    window.basePage = new BasePage()

  class BasePage
    constructor: ->
      @_resizeDelayed()
      @_imageLoader()
      @_skipAddressValidation()
      @_initController()
      @_initLoadingIndicator()
      @_showToTopButton()
      @_goToTop()
      @_delayedBasketRestore()
      @_settingsPanel()
      @_breadcrumbToMicrodata()
      @_seoLink()
      @_showHidePasswordAlternative()
      @_addSlashesToDate()
      @_phoneNumbers()
      @_hideNewsletterPopinAfterDisplay()
      @_disallowSemicolonInInputFields()

    _initController: ->
      controller.scan()

      $(document).on 'before:kryptonite', (e, action) ->
        includeSelf = action == 'replaceWith'
        controller.destroy $(e.target), includeSelf

      $(document).on 'pjax:beforeSuccess', (data, status, xhr, options, context) ->
        $selector = $(context.container.selector)
        if $selector?
          controller.destroy $selector

      $(document).ajaxSuccess (context) ->
        requestAnimationFrame ->
          controller.scan()

      $(document).ajaxSuccess =>
        @_imageLoader()

    _initLoadingIndicator: ->
      self = @

      $('form.showLoading').on 'submit', (e) ->
        self._showLoadingProgress()

      $(document).bind('ajaxSend', (event, jqxhr, settings) ->
        if self.showAjaxLoadingIndicator(settings)
          self._showLoadingProgress()
        return
      ).bind 'ajaxComplete', ->
        if $('#loading-overlay').closest("#modalOverlayRight").length < 1
          self._hideLoadingProgress()
        return

    _showLoadingProgress: ->
      overlay = jQuery('<div data-test-loading-overlay id="loading-overlay"><div class="loading-circle"></div></div>')
      overlay.appendTo document.body
      return

    _hideLoadingProgress: ->
      $('body #loading-overlay').remove()
      return

    _resizeDelayed: ->
      mq.update()
      timer = null
      $(window).on 'resize', ->
        mq.update()
        clearTimeout(timer) if timer
        timer = setTimeout(->
          $(window).trigger('resizeDelayed')
        , 200)

    _imageLoader: ->
      $('.article__picture, .article__color').on 'inview', 'img[data-src]', ->
        $this = $(this)
        $this.attr 'src', $this.attr('data-src')
        $this.removeAttr 'data-src'
        return

    _skipAddressValidation: ->
      $('.addressValidation').on 'change', (e) ->
        form = $(e.target).closest('form')
        form.find('.skipAddressValidation').val('false')

    _showToTopButton: ->
      $(window).on 'scroll', ->
        top = $(window).scrollTop()
        if (top > 300)
          $('.to-top').addClass('visible')
        else
          $('.to-top').removeClass('visible')

    _goToTop: ->
      $('body').on 'click', '.to-top', (e) ->
        $('html, body').animate {scrollTop: 0}, 'slow'

    _delayedBasketRestore: ->
      self = @
      $ ->
        if self.meta 'bskt_rest'
          $.kryptonite
            type: "GET"
            url: '/basket-restore'

    meta: (name) ->
      return $("meta[name='#{name}'], meta[property='#{name}']").attr("content")

    showAjaxLoadingIndicator: (settings) ->
      modalLoadingIndicator = $(this).attr('data-modal-loading-indicator')

      if !modalLoadingIndicator
        if settings.xhrFields?.showLoadingIndicator?
          showLoadingIndicator = settings.xhrFields.showLoadingIndicator
          delete settings.xhrFields.showLoadingIndicator
          return showLoadingIndicator

        url = settings.url
        return url.indexOf('widget.mondialrelay') == -1 and url.indexOf('widget-colissimo') == -1 and url.indexOf('avis-verifies.com') == -1 and url.indexOf('netreviews.eu') == -1 and url.indexOf('clickEvent') == -1 and url.indexOf('searchsuggestion') == -1 and url.indexOf('servicelayer') == -1 and url.indexOf('basket-restore') == -1 and url.indexOf('firstname') == -1 and url.indexOf('autocomplete') == -1

    _settingsPanel: ->
      return unless $('#settingspanel')

      formatNumber = (number) ->
        return number if (number > 9 || number == "00")
        return '0' + number

      $('#settingspanel a.changeTime').on 'click', (e) ->
        e.preventDefault()
        day = formatNumber $('#settingspanel .day :selected').val()
        month = formatNumber $('#settingspanel .month :selected').val()
        year = $('#settingspanel .year :selected').val()
        hour = formatNumber $('#settingspanel .hour :selected').val()
        minute = formatNumber $('#settingspanel .minute :selected').val()
        second = "00"
        url = window.location.href
        if (url.indexOf('?') > 0)
          url = url.substring(0, url.indexOf('?'))
        url = url + '?previewDate=' + day + month + year + hour + minute + second
        window.location = url

      $('#settingspanel a.reset').on 'click', (e) ->
        e.preventDefault()
        url = window.location.href
        if (url.indexOf('?') > 0)
          url = url.substring(0, url.indexOf('?'))
        url = url + '?previewDate=reset'
        window.location = url

      timeout = null
      $('#settingspanel').on 'mouseover', (e) ->
        e.preventDefault()
        $(@).addClass('hover')
        window.clearTimeout(timeout)

      $('#settingspanel').on 'mouseout', (e) ->
        e.preventDefault()
        $el = $(@)
        timeout = window.setTimeout(
          ->
            $el.removeClass('hover')
        , 3000
        )

    _breadcrumbToMicrodata: ->
      urlPrefix = document.location.protocol+'//'+document.location.host
      data = '{"@context": "http://schema.org","@type": "BreadcrumbList","itemListElement":['
      $breadcrumb = $('.bread-crumb').first()
      breadcrumbItems = $breadcrumb.find('.bread-crumb__item')

      breadcrumbItems.each (index, elem) =>
        if(index!=0)
          data += ','

        data += '{"@type": "ListItem","position": '+(index+1)+',"item":{'
        $anchor = $(elem).find('a')
        if($anchor.length > 0 && $anchor.attr('href') == '#')
          data += '"@id": "'+document.location+'",'
        else if($anchor.length > 0)
          data += '"@id": "'+urlPrefix+$(elem).find('a').attr('href')+'",'
        else
          data += '"@id": "'+document.location+'",'
        data += '"name": "'+$(elem).find('span').html()+'"}}'

      data += ']}'
      @_writeMicrodataToBody(data)

    _writeMicrodataToBody: (data) ->
      script = document.createElement('script');
      script.type = "application/ld+json";
      script.innerHTML = data
      $('body').append(script)

    _seoLink: ->
      $body = $('body')
      $body.on 'click', '[data-link]', (e) ->
        e.preventDefault()
        modalType = $(this).attr('data-modal-type')
        if ($(e.currentTarget).data('modal-type') != 'modal-right')
    #     without if, right-panel-layer over link klick will not open in layer but redirect to link
          $link = $(e.currentTarget)
          $form = $('<form>').attr("method", "POST")
            .attr("action", "/prg")
            .attr("target", $link.attr("target"))

          $input = $('<input>').attr('type', 'hidden')
            .attr('name', 'link')
            .attr('value', $link.data('link'))
          $form.append($input)
          $body.append($form)
          $form.submit()

    _showHidePasswordAlternative: ->
      $('.togglePassword__switch').on 'click', (e) ->
        # refactor after merging in master $(this).closest("[data-controller-element=toggle-password-wrap]")
        container = $(this).parent()
        container.find('.togglePassword__switch').removeClass('hidden')
        $(this).addClass('hidden')
        input = $(this).parent().siblings()
        if (input.attr("type") == "password")
          input.attr("type", "text")
        else
          input.attr("type", "password")

    _isNumberOrSpecial: (e) ->
      if (e.key.length > 1)
        return true
      return e.key.match(/^[0-9]$/) and !(e.altKey or e.ctrlKey or e.metaKey or e.shiftKey)

    _addSlashesToDate: ->
      self = @
      $('.dateWithSlashes')[0]?.addEventListener 'input', (e) ->
          input = e.target.value.replace /\D/g, ''
          if input.length > 2 and input.length <= 4
            input = "#{input.slice(0, 2)}/#{input.slice(2)}"
          else if input.length > 4
            input = "#{input.slice(0, 2)}/#{input.slice(2, 4)}/#{input.slice(4, 8)}"
          e.target.value = input

    _phoneNumbers: ->
      self = @
      $('.phoneNumber').on 'keydown', (e) ->
        if !self._isNumberOrSpecial(e)
          e.stopPropagation()
          e.preventDefault()

    _hideNewsletterPopinAfterDisplay: ->
      if $('.newsletter-flyout-container').length > 0
        $.cookie('newsletter_flyout_blocked', 1, { path: '/', expires: 30 })

    _disallowSemicolonInInputFields: ->
      self = @
      $('input[type="text"]:not([readonly="true"]), input[type="email"]:not([readonly="true"])').on 'keydown', (e) ->
        if (e.key == ";")
          e.preventDefault()

      $('input[type="text"]:not([readonly="true"]), input[type="email"]:not([readonly="true"])').on 'paste', (e) ->
        $el = $(e.currentTarget)
        pastedContent = e.originalEvent.clipboardData.getData("text")
        cleanedContent = pastedContent.replace(/;/g, '').trim()
        e.preventDefault()
        $el.val($el.val() + cleanedContent)
